var TESNAV = TESNAV || {};

TESNAV.activityAlert = function() {
  var navHome = TESNAV.$container.find('.js-nav-home');
  var toggleIcon = TESNAV.$container.find('.js-toggle-icon');


  if ((typeof Cookies !== 'undefined') && !Cookies.get('TESCookieUser') || !navHome) {
    return;
  }

  var notificationUrl = '/api/v1/notifications';
  var refreshTimer = 1000 * 30;
  var activityAlertBubble = document.createElement('span');
  activityAlertBubble.className = 'alert-bubble';

  function updateNotificationCount(notificationCount) {
    if (!document.body.contains(activityAlertBubble)) {
      navHome.append(activityAlertBubble);
      toggleIcon.addClass('icon-bars--notify-circle');
    }
    activityAlertBubble.textContent = notificationCount;
  }

  function checkForActivity() {
    jQuery.get(notificationUrl)
      .done(function (data) {
        if(typeof data.notifications === "number" && data.notifications > 0 ){
          var alertBubbleText = data.notifications > 9 ? '9+' : data.notifications;
          updateNotificationCount(alertBubbleText);
        }
      })
  }

  if (Boolean(window.location.pathname.match(/^\/uk\/$|^\/uk$|^\/([?]{1}.*)?$/))){
    setInterval(checkForActivity, refreshTimer);
  } else {
    checkForActivity();
  }
};